import { useCallback } from 'react';
import { GET_PUBLISHED_COLLECTIONS_QUERY } from '../queries/collectionsQuery';
import { useCollectionsData } from './useCollectionsData';
export function usePublishedCollections(props) {
  const commonCollections = useCollectionsData(GET_PUBLISHED_COLLECTIONS_QUERY, props);
  const getCollectionSlugs = useCallback(() => {
    return commonCollections.data.reduce((slugs, collection) => {
      if (collection.publishedListing) {
        slugs.push(collection.publishedListing.slug);
      }
      return slugs;
    }, []);
  }, [commonCollections.data]);
  const getDisplayedCollections = useCallback(() => {
    return commonCollections.data.filter(collection => {
      var _collection$published;
      return (_collection$published = collection.publishedListing) === null || _collection$published === void 0 ? void 0 : _collection$published.displayed;
    }).sort((a, b) => b.publishedListing.updatedAt - a.publishedListing.updatedAt);
  }, [commonCollections.data]);
  return Object.assign({}, commonCollections, {
    getDisplayedCollections,
    getCollectionSlugs
  });
}